import {Component, Input} from '@angular/core';
import {IOrder} from "../../../orders.interface";
import {IEcommerceView} from "../../../../ecommerce-product.interface";

@Component({
    selector: 'db-order-info',
    templateUrl: './order-info.component.html',
    styleUrl: './order-info.component.scss',
    standalone: false
})
export class OrderInfoComponent {
  @Input() order: IOrder;
  @Input() pageData: IEcommerceView;
}
